(function($) {
    $.fn.reanimate = function(options) {
        //Zugriff von aussen auf eigenschaften möglich  
        //für meinen Fall eigentlich nicht nötig
        var settings = $.extend({}, $.fn.reanimate.defaults, options);
        //var v=$.extend({},$.fn.reanimate.defaults,options);

        //privat nur für plugin zugänglich
        var scrolling = {
            last_y: 0,
            hit: false, //getroffen
            out_hit: true //nach einem Treffen wieder raus aus Viewport?
        }

        var view = {
            docViewTop: 0,
            docViewBottom: 0,
            elemTop: 0,
            elemBottom: 0
        }
        debug(this);


        if($(window).width() > 1024) {
        if ($(settings.idNameTrigger).length == 1) {
            $(window).scroll(function() {
                view.docViewTop = $(window).scrollTop();
                view.docViewBottom = view.docViewTop + $(window).height();
                if ($(settings.idNameTrigger) && $(settings.idNameTrigger).offset()) {
                    view.elemTop = $(settings.idNameTrigger).offset().top;
                    view.elemBottom = view.elemTop + $(this).height();

                    //window.console.log("docViewTop="+view.docViewTop);
                    //window.console.log("docViewBottom="+view.docViewBottom);    
                    //window.console.log(scrolling.last_y+" - "+view.docViewTop+" > "+settings.next_check_y);
                    if (Math.abs(scrolling.last_y - view.docViewTop) > settings.next_check_y) {
                        //alert("50px");
                        window.console.log("next check");
                        scrolling.last_y = view.docViewTop;
                        if (view.docViewBottom - settings.offset_y > view.elemTop) { //alert("gree");
                            //tausche klasse aus!
                            if (scrolling.out_hit) {
                                scrolling.hit = true;
                                scrolling.out_hit = false;
                                // alert(hit);
                                window.console.log("hit");
                                var el = $(settings.idNameTrigger);
                                window.console.log(el.attr("class"));
                                var newone = el.clone(true);
                                el.before(newone);
                                el.remove();
                                //$("." + el.attr("class") + ":last").remove();
                                $(settings.idNameTrigger).addClass("animated");
                            }
                            //$('#team-section').removeClass("animated").addClass("animated");

                            //  $('#team-section').css({transition: 'opacity, left 3s ease-in'});
                        } else {
                            scrolling.out_hit = true;
                            scrolling.hit = false;
                        }
                    }
                }
            });
        }}
        

        $(settings.idNameTrigger).on('oanimationend animationend webkitAnimationEnd', function() {
            //alert("team-section end animation");
            $(settings.idNameTrigger).removeClass("animated");
        });

        //
        // this.each(function(){
        //     window.console.log ($(this).css('color'));
        // });

        //private Funktion
        function debug($obj) {
            window.console.log(settings.offset_y);

            //window.console.log($(this.size()));
            //alert(settings.offset_y);
        }

        //Parameter nach aussen
        $.fn.reanimate.defaults = {
            offset_y: 50,
            idNameTrigger: '#show1',
            next_check_y: 150
        };

    }
}(jQuery));